// extracted by mini-css-extract-plugin
export default {"wrapper":"Questions_wrapper__h5d5H","container":"Questions_container__g0YHm","info":"Questions_info__Uixe2"};